module.exports = __webpack_public_path__ + "static/media/grras-logo.3ddebb6c.png";